import { graphql } from 'gatsby'

// eslint-disable-next-line no-restricted-exports
export { default } from './Blog'

export const query = graphql`
  query ($slug: String!, $limit: Int!, $skip: Int!) {
    ghostTag(slug: { eq: $slug }) {
      ...GhostTagFields
    }
    allGhostTag(sort: { name: ASC }) {
      nodes {
        ...GhostTagFields
        postCount
      }
    }
    allGhostPost(
      sort: { published_at: DESC }
      filter: { tags: { elemMatch: { slug: { eq: $slug } } } }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        ...GhostPostFields
      }
    }
  }
`
